var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Carousel from 'bootstrap/js/dist/carousel';
export class Project extends Component {
    constructor() {
        super('Project', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.d-fix').addClass('d-none');
            setTimeout(() => {
                $('.d-fix').removeClass('d-none');
            }, 400);
            if ($('.single-project').length > 0) {
                /* Init carousel */
                const carousel = new BS_Carousel('#project-gallery');
                Project.loadSlides($('#project-gallery .active'));
                Project.updateCaption($('#project-gallery .active'));
                /* Carousel navigation */
                $('#project-gallery-container').on('click', () => {
                    if (Project.mousePosition.x > $(window).width() / 2) {
                        carousel.next();
                    }
                    else {
                        carousel.prev();
                    }
                });
                $('#project-gallery-container').on('slide.bs.carousel', (event) => {
                    const slide = $('#project-gallery .carousel-item').eq(event.to);
                    Project.loadSlides(slide);
                    $('#var-gallery-index').text(event.to + 1);
                    Project.updateCaption(slide);
                });
                /* Cursor */
                $(document).on('mousemove', (event) => {
                    Project.mousePosition = { x: event.pageX, y: event.pageY };
                    if (event.pageY > $('header').height()) {
                        $('#project-gallery-container').addClass('no-cursor');
                        $('#gallery-cursor').removeClass('d-none');
                    }
                });
                $('#project-gallery-container').on('mouseenter', (event) => {
                    $('#gallery-cursor').removeClass('d-none');
                }).on('mouseleave', (event) => {
                    $('#gallery-cursor').addClass('d-none');
                });
                requestAnimationFrame(Project.placeCursor);
                /* Informations toggle */
                $('#btn-toggle-project-informations').on('click', (event, button) => {
                    event.preventDefault();
                    button.toggleClass('active');
                    $('#project-gallery').toggleClass('grayscale');
                    Project.setInformationMaxHeight();
                    if (button.hasClass('active')) {
                        $('#project-informations').css('max-height', 'var(--max-height)');
                    }
                    else {
                        $('#project-informations').css('max-height', '0');
                    }
                });
                $(window).on('resize', () => {
                    Project.setInformationMaxHeight();
                });
                Project.setInformationMaxHeight();
            }
            this.success();
        });
    }
    static loadSlides(slide) {
        Project.loadImage(slide);
        if (slide.next().length > 0)
            Project.loadImage(slide.next());
    }
    static loadImage(slide) {
        const image = slide.find('.project-image');
        const source = image.data('src');
        const imageLoader = new Image();
        imageLoader.src = source;
        imageLoader.onload = () => {
            image.css('background-image', `url(${image.data('src')})`);
            slide.addClass('loaded');
        };
    }
    static placeCursor() {
        $('#gallery-cursor').css({
            left: Project.mousePosition.x,
            top: Project.mousePosition.y,
        });
        if (Project.mousePosition.x > $(window).width() / 2) {
            $('#gallery-cursor').addClass('right');
        }
        else {
            $('#gallery-cursor').removeClass('right');
        }
        requestAnimationFrame(Project.placeCursor);
    }
    static updateCaption(slide) {
        const caption = slide.find('.project-image').data('caption');
        if (!caption || caption === '') {
            $('#var-gallery-caption').addClass('d-none');
        }
        else {
            $('#var-gallery-caption').removeClass('d-none');
            $('#var-gallery-caption').text(caption);
        }
    }
    static setInformationMaxHeight() {
        let maxHeight = $('#project-informations .container-fluid').height();
        if (maxHeight > $(window).height() - $('header').height())
            maxHeight = $(window).height() - $('header').height();
        $('#project-informations').css('--max-height', `${maxHeight}px`);
    }
}
Project.mousePosition = { x: 0, y: 0 };
